
<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>堂食菜品信息</h3>
      <el-form>
        <div style="display: flex">
          <el-form-item label="请选择门店" style="margin-right: 20px">
            <el-select
              v-model="formInline.shop_id"
              placeholder="请选择"
              @change="getCategory()"
            >
              <el-option
                v-for="index in typeData"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导入" v-if="this.platform === '1'">
            <el-button
                type="primary"
                style="background: #1890ff"
                @click="copyAll"
            >一键导入</el-button>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item label="请选择标签属性" style="margin-right: 20px">
            <el-select
              v-model="formInline.dish_attr_value_ids"
              placeholder="请先选择标签"
            >
              <el-option
                v-for="index in attrList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="搜索" style="margin-right: 20px">
            <el-input
              placeholder="请输入内容"
              v-model="formInline.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="
              min-width: 150px;
              margin-left: 20px;
              display: flex;
              align-items: flex-end;
            "
          >
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="getTableData"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="setFormInline"
              >重置</el-button
            >
            <!-- <el-button type="primary" style="background: #1890ff;" @click="setFormInlines">查看全部</el-button> -->
          </el-form-item>
        </div>
      </el-form>
      <div style="width: 100%; height: auto; display: flex">
        <div class="webList" v-if="categoryData.length">
          <div class="webList_1">
            <div
              :class="
                (item.id === formInline.category_ids &&
                  'webList_1_name name_color') ||
                'webList_1_name'
              "
              style="cursor: default"
              v-for="(item, index) in categoryData"
              :key="index"
              @click="() => categoryList(item.id)"
            >
              <img class="webList_icon" :src="item.image" />
              {{ item.name }}
            </div>
          </div>
          <div class="webList_2">
            <!-- <div class="webList_1_name" v-for="item in tableData" :key="item.id">{{item.amount}}</div> -->
            <div
              :class="
                (item.id == user_dish_list_id && 'webList_2_list name_color') ||
                'webList_2_list'
              "
              style="cursor: default"
              v-for="item in tableData"
              :key="item.id"
              @click="getEdit(item)"
            >
              <img :src="item.dish_base.image" class="webList_2_img" />
              <div>
                <div class="webList_2_name">
                  {{ item.dish_base.name || '暂无商品名称' }}
                </div>
                <div
                  class="webList_2_value"
                  v-for="items in item.dish_unit_prices"
                  :key="items.id"
                >
                  <div>
                    规格价格：{{ items.price }}元/{{
                      items.dish_unit.unit_amount
                    }}{{ items.dish_unit.name }}
                  </div>
                  <div>计量单位：{{ items.dish_unit.display_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_centers_y" v-if="this.platform === ''">
            <div style="flex: 1" class="vubuttons" @click="onSubmit_ca" >
              新增类目
            </div>
            <div style="flex: 2" class="vubuttons" @click="onSubmit">
              新增菜品
            </div>
          </div>
        </div>
        <div class="webListValue" v-if="user_dish_list_id && form.id">
          <div class="value_name">{{ form.name }}</div>
          <div class="value_namex">{{ form.intro }}</div>
          <div
            class="value_price"
            v-for="item in form.dish_unit_prices"
            :key="item.id"
          >
            {{ item.dish_unit.unit_amount }}{{ item.dish_unit.name }}/{{
              item.dish_unit.display_name
            }}:
            <div class="value_price_s">价格:￥{{ item.price }}</div>
            <div class="value_price_s">/vip价格:￥{{ item.vip_price }}</div>
          </div>
          <div class="value_price">
            重量偏差:
            <div class="value_price_s">{{ form.deviation }}g</div>
          </div>
          <div class="value_price">
            总重量:
            <div class="value_price_s">{{ form.amount }}g</div>
          </div>
          <!-- <template slot-scope="scope"> -->
          <div class="value_names">菜品标签</div>
          <div class="value_attr">
            <div class="value_attr_s">
              <el-tag
                style="margin-right: 5px"
                v-bind:closable="platform === ''"
                v-for="tag in form.dish_attr_map"
                :key="tag.id"
                @close="deleteLaole(tag.id)"
                >{{ tag.dish_attr_value.value }}</el-tag
              >
            </div>
          </div>
          <div class="value_names">所属类目</div>
          <div class="value_attr">
            <div class="value_attr_s" style="justify-content: center">
              <el-tag
                style="margin-right: 5px"
                v-bind:closable="platform === ''"
                v-for="tag in form.category_dishes"
                :key="tag.id"
                @click="setCategory(tag)"
                @close="deleteCategory(tag.id)"
                >{{ tag.category.name }}</el-tag
              >
            </div>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>卡路里</div>
              <div>{{ form.calorie }}C</div>
            </div>
            <el-progress
              :percentage="form.calorie"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>碳水化合物</div>
              <div>{{ form.carbohydrate }}g</div>
            </div>
            <el-progress
              :percentage="form.carbohydrate"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>蛋白质</div>
              <div>{{ form.protein }}g</div>
            </div>
            <el-progress
              :percentage="form.protein"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>脂肪</div>
              <div>{{ form.fat }}g</div>
            </div>
            <el-progress
              :percentage="form.fat"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div
            class="value_attr_s"
            style="justify-content: center; margin-top: 10px"
          >
            <el-button v-if="this.platform === ''"
              size="mini"
              style="margin-top: 5px"
              @click="setCategorys(form)"
              >新增所属类目</el-button
            >
            <el-button v-if="this.platform === ''"
              size="mini"
              style="margin-top: 5px"
              @click="setLaole(form.id)"
              >新增标签</el-button
            >
            <el-button v-if="this.platform === ''"
              size="mini"
              style="margin-top: 5px"
              @click="handleEdit(form)"
              >编辑</el-button
            >
            <el-button v-if="this.platform === ''"
              size="mini"
              style="margin-top: 5px"
              @click="handleDelete(form)"
              >删除</el-button
            >
            <el-button v-if="this.platform === '1'"
                size="mini"
                style="margin-top: 5px"
                @click="copyPlatformDish(form)"
            >复制</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 列表弹框 -->
    <el-dialog
      title="菜品信息"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          label="基础菜品搜索"
          :label-width="formLabelWidth"
          v-if="!putStatus"
        >
          <el-autocomplete
            v-model="form.searchAsync"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          label="堂食外卖"
          :label-width="formLabelWidth"
          prop="category_id"
        >
          <div style="color: #999">堂食</div>
        </el-form-item>
        <el-form-item label="菜品名" :label-width="formLabelWidth" prop="name">
          <div style="display: flex; margin: 1px" >
            <el-input v-model="form.name" autocomplete="off"></el-input>
            <el-button type="primary" @click="showRaw">+菜品BOM管理</el-button>
          </div>
        </el-form-item>
        <div style="width: 110px; text-align: right; margin-bottom: 20px">
          菜品BOM配置
        </div>

        <el-form-item label :label-width="'30px'" v-if="this.rawShow">
          <el-form-item
              label="请选择基础原料"
              :label-width="formLabelWidth"
              style="margin-bottom: 4px"
          >
            <el-select
                v-model="form.raw_id"
                placeholder="请选择"
                @change="rawChange"
            >
              <el-option
                  v-for="index in rawData"
                  v-bind:key="index.id"
                  :label="index.name"
                  :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原料配量" :label-width="formLabelWidth">
            <div style="display: flex; width: 220px">
              <el-input v-model="form.raw_num" autocomplete="off" @input='rawNumChange'>
                <template slot="append">{{form.raw_unit}}</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="原料分类" :label-width="formLabelWidth">
            <div style="display: flex; width: 200px">
              {{form.raw_category}}
            </div>
          </el-form-item>
          <el-form-item label="原料成本" :label-width="formLabelWidth">
            <div style="display: flex; width: 200px">
              {{raw_cost/100}}元
            </div>
            <div>
              备注: 菜品BOM配置按成品菜10千克为标准配置所需原料清单。
            </div>
          </el-form-item>

          <el-button type="primary" @click="addRaws" >新增</el-button>
          <el-button type="primary" @click="removeRaws" >删除</el-button>
          <el-table
              :fit="false"
              border
              show-summary
              :data="tableRawData"
              :summary-method="getTotal"
              :cell-style="() => 'text-align: center;'"
              :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
          >
            <template slot="empty">
              <noCart></noCart>
            </template>
            <el-table-column label="原料名称" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.raw_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="原料分类" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.category}}</span>
              </template>
            </el-table-column>
            <el-table-column label="原料配量" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }}{{scope.row.raw_unit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="原料价格" width="180">
              <template slot-scope="scope">
                <span>{{ scope.row.raw_price/100 }}元</span>
              </template>
            </el-table-column>
          </el-table>
          <el-button  @click="calcNutrition" >计算营养数据</el-button>
        </el-form-item>


        <div style="width: 110px; text-align: right; margin-bottom: 20px">
          基础配置
        </div>
        <el-form-item label :label-width="'30px'">
          <el-form-item
            label="请选择标签"
            :label-width="formLabelWidth"
            prop="dish_attr_id"
          >
            <el-select
              v-model="form.dish_attr_id"
              placeholder="请选择"
              multiple
            >
              <el-option
                v-for="index in attrList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="菜品规格"
            style="margin-top: 20px"
            :label-width="formLabelWidth"
            prop="dish_unit_id"
          >
            <el-select
              multiple
              :multiple-limit="1"
              v-model="form.dish_unit_id"
              placeholder="请选择"
              @change="getdish_unit_id"
            >
              <el-option
                v-for="index in unitData"
                v-bind:key="index.id"
                :label="`${index.unit_amount}${index.name}/${index.display_name}`"
                :value="index.id"
              ></el-option>
            </el-select>
            <div
              v-for="index in unitList"
              :key="index.id"
              style="display: flex"
            >
              <el-form-item
                :label="`${index.unit_amount}${index.name}/${index.display_name}/价格`"
                :label-width="'150px'"
                style="margin-top: 10px"
              >
                <div style="display: flex">
                  <el-input
                    style="flex: 1"
                    v-model="index.price"
                    type="number"
                    autocomplete="off"
                  ></el-input>
                  <span style="margin-left: 5px">元</span>
                </div>
              </el-form-item>
              <el-form-item
                :label="`${index.unit_amount}${index.name}/${index.display_name}/vip价格`"
                :label-width="'150px'"
                style="margin-top: 10px"
              >
                <div style="display: flex">
                  <el-input
                    style="flex: 1"
                    v-model="index.vip_price"
                    type="number"
                    autocomplete="off"
                  ></el-input>
                  <span style="margin-left: 5px">元</span>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </el-form-item>

        <el-form-item
          label="创建时间"
          v-if="form.created_at"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.created_at"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="更新时间"
          v-if="form.updated_at"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.updated_at"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth" prop="intro">
          <el-input v-model="form.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片" :label-width="formLabelWidth">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item
          label="请选择类目"
          :label-width="formLabelWidth"
          prop="category_id"
        >
          <el-select v-model="form.category_id" placeholder="请选择" multiple>
            <el-option
              v-for="index in categoryData"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="卡路里"
          :label-width="formLabelWidth"
          prop="calorie"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.calorie" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">C</span>
          </div>
        </el-form-item>
        <el-form-item label="油" :label-width="formLabelWidth" prop="calorie">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.oil" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="盐" :label-width="formLabelWidth" prop="calorie">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.salt" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="糖" :label-width="formLabelWidth" prop="calorie">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.sugar" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="脂肪" :label-width="formLabelWidth" prop="fat">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.fat" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="碳水化合物"
          :label-width="formLabelWidth"
          prop="carbohydrate"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.carbohydrate" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="蛋白质"
          :label-width="formLabelWidth"
          prop="protein"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.protein" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="钠"
          :label-width="formLabelWidth"
          prop="na"
        >
          <div style="display: flex; width: 220px">
            <el-input v-model="form.na" autocomplete="off"></el-input>
            <span style="margin-left: 10px;width:30px">mg</span>
          </div>
        </el-form-item>
        <el-form-item
          label="重量偏差"
          v-if="isInput"
          :label-width="formLabelWidth"
          prop="deviation"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.deviation" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="总重量"
          v-if="isInput"
          :label-width="formLabelWidth"
          prop="amount"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.amount" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="statusStore('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 类目弹框 -->
    <el-dialog title="选择类目" :visible.sync="dialogFormVisibles">
      <el-form>
        <el-form-item label="请选择类目">
          <el-select v-model="categorySet.category_id" placeholder="请选择">
            <el-option
              v-for="index in categoryData"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibles = false">取 消</el-button>
        <el-button type="primary" v-if="putCategoryTest" @click="putCategory"
          >确 定</el-button
        >
        <el-button type="primary" v-if="!putCategoryTest" @click="postCategory"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 标签弹框 -->

    <el-dialog title="标签属性" :visible.sync="dialogFormVisibleLabel">
      <el-form>
        <el-form-item label="请选择标签属性" style="margin-right: 20px">
          <el-select
            v-model="Label_dish_attr.dish_attr_value_id"
            placeholder="请先选择标签"
          >
            <el-option
              v-for="index in attrList"
              v-bind:key="index.id"
              :label="index.value"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleLabel = false">取 消</el-button>
        <el-button type="primary" v-if="!putCategoryTest" @click="postLaole"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- //新增菜 -->
    <el-dialog title="类目信息" :visible.sync="dialogFormVisible_ca">
      <el-form :model="ca_form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="ca_form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="ca_form.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="堂食外卖" :label-width="formLabelWidth">
          <el-select v-model="ca_form.c_type" placeholder="请选择">
            <el-option label="堂食" :value="1"></el-option>
            <el-option label="外卖" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="setStore_ca()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="一键导入" :visible.sync="dialogCopyVisible">
      <el-form :model="ca_form">
        <el-form-item label="日志" :label-width="formLabelWidth">
          <el-input
              type="textarea"
              :rows="10"
              :disabled="true"
              v-model="copyDishLog">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="stopCopyLogs">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script scoped>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      copyDishLog:'',
      interval: 0,
      dialogCopyVisible:false,
      platform: '',
      //列表数据
      rawOptions:[
        {
          label:'蔬菜',
          value: 'Vegetable'
        },
        {
          label:'干杂',
          value: 'DryMix'
        },
        {
          label:'调料',
          value: 'Dressing'
        },
        {
          label:'冻品',
          value: 'Frozen'
        },
        {
          label:'鲜肉',
          value: 'Meat'
        },
        {
          label:'鱼类海鲜',
          value: 'Fish'
        },
        {
          label:'鲜禽',
          value: 'Bird'
        },
        {
          label:'清洁用品',
          value: 'Clean'
        },
        {
          label:'一次性耗材用品',
          value: 'SingleUse'
        },
        {
          label:'其他日常用品',
          value: 'Other'
        },
      ],
      rawShow: true,
      tableData: [],
      tableRawData: [],
      rawData:[],
      // 门店数据
      typeData: [],

      // 类目数据
      categoryData: [],
      //单位数据
      unitData: [],
      // 绑定参数
      formInline: {
        // 门店
        shop_id: 0,
        //搜索
        name: '',
        //类目
        category_ids: '',
        //标签
        dish_attr_value_ids: '',
      },
      // 弹窗控住
      dialogFormVisible: false,
      dialogFormVisible_ca: false,
      dialogFormVisibles: false,
      dialogFormVisibleLabel: false,
      // 类目
      categorySet: {},
      //标签属性
      Label_dish_attr: {
        dish_attr_id: '',
        dish_attr_value_id: '',
      },
      putCategoryTest: false,
      raw_cost: 0,
      // 弹窗数据
      form: {
        platform: '',
        name: '',
        intro: '',
        image: '',
        price: 0,
        calorie: 0,
        oil: 0,
        salt: 0,
        sugar: 0,
        fat: 0,
        carbohydrate: 0,
        protein: 0,
        na: 0,
        deviation: 0,
        dish_unit_id: [],
        amount: 0,
        action_type: 1, //1不置顶 2制定
        category_id: [],
        dish_attr_id: [],
        sticky: 1,
        order_seq: 22,
      },
      // 类目新增
      ca_form: {},
      // 宽度
      formLabelWidth: '120px',
      // 是否修改
      putStatus: false,
      unitList: [],
      //七牛
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      rules: {
        name: [
          { required: true, message: '请输入菜品名', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        intro: [{ required: true, message: '请输入简介', trigger: 'blur' }],

        category_id: [
          { required: true, message: '类目不能为空', trigger: 'blur' },
        ],

        dish_attr_id: [
          { required: true, message: '标签不能为空', trigger: 'blur' },
        ],
        dish_unit_id: [
          { required: true, message: '菜品规格不能为空', trigger: 'blur' },
        ],
        calorie: [
          { required: true, message: '卡路里不能为空', trigger: 'blur' },
        ],
        oil: [{ required: true, message: '油不能为空', trigger: 'blur' }],
        salt: [{ required: true, message: '盐不能为空', trigger: 'blur' }],
        sugar: [{ required: true, message: '糖不能为空', trigger: 'blur' }],
        fat: [{ required: true, message: '脂肪不能为空', trigger: 'blur' }],
        carbohydrate: [
          { required: true, message: '碳水化合物不能为空', trigger: 'blur' },
        ],
        protein: [
          { required: true, message: '蛋白质不能为空', trigger: 'blur' },
        ],
        na: [
          { required: true, message: '钠不能为空', trigger: 'blur' },
        ],
        deviation: [
          { required: true, message: '重量偏差不能为空', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '总重量不能为空', trigger: 'blur' },
        ],
      },
      user_dish_list_id: '',
      customColors: [
        { color: '#0dce8c', percentage: 40 },
        { color: '#2782e8', percentage: 80 },
        { color: '#ff0000', percentage: 100 },
      ],
      attrList: [],
      isInput: true,
    };
  },
  methods: {
    addRaws(){
      let raw = this.rawData.find(item => item.id === this.form.raw_id)
      this.tableRawData.push({
        raw_id: raw.id,
        raw_name: raw.name,
        raw_category: raw.category,
        category: this.translateCategory(raw.category),
        amount: this.form.raw_num,
        raw_price: this.raw_cost,
        raw_unit: raw.unit,
        calorie: raw.calorie,
        carbohydrate: raw.carbohydrate,
        fat: raw.fat,
        protein: raw.protein,
        na: raw.na,
        oil: raw.oil,
        salt: raw.salt,
        sugar: raw.sugar,
        unit_price: raw.unit_price,
      })
    },
    removeRaws(){
      if (this.tableRawData.length > 0) {
        this.tableRawData.pop()
      }
    },
    calcNutrition(){
      let calorie = 0.0
      let carbohydrate = 0.0
      let fat = 0.0
      let protein = 0.0
      let na = 0.0
      let oil = 0.0
      let salt = 0.0
      let sugar = 0.0
      let totalAmount = 0

      for (let raw of this.tableRawData) {
        let num = parseFloat(raw.amount)
        let rate = num / 10.0
        let cnt = rate * 50

        calorie += cnt * (raw.calorie / 1000.0)
        carbohydrate += cnt * (raw.carbohydrate / 1000.0)
        fat += cnt * (raw.fat / 1000.0)
        protein += cnt * (raw.protein / 1000.0)
        na += cnt * (raw.na / 1000.0)
        salt += cnt * (raw.salt / 1000.0)
        sugar += cnt * (raw.sugar / 1000.0)
        oil += cnt * (raw.oil / 1000.0)
      }

      this.form.calorie = calorie.toFixed(2)
      this.form.carbohydrate = carbohydrate.toFixed(2)
      this.form.fat = fat.toFixed(2)
      this.form.protein = protein.toFixed(2)
      this.form.na = na.toFixed(2)
      this.form.salt = salt.toFixed(2)
      this.form.sugar = sugar.toFixed(2)
      this.form.oil = oil.toFixed(2)

      this.form = {...this.form}
    },

    rawChange(val){
      let raw = this.rawData.find(item => item.id === val)
      let category = this.translateCategory(raw.category)

      console.log(raw.unit_price)
      console.log(raw)
      console.log(this.form.raw_num)
      this.form.raw_category = category
      this.form.raw_unit = raw.unit
      this.raw_cost = this.form.raw_num * raw.unit_price

    },
    rawNumChange(val) {
      console.log(val)
      let raw = this.rawData.find(item => item.id === this.form.raw_id)
      this.raw_cost = val * raw.unit_price
    },
    translateCategory(value) {
      for (let option of this.rawOptions){
        if (option.value === value) {
          return option.label
        }
      }
      return ''
    },
    showRaw(){
      this.rawShow = !this.rawShow
    },
    querySearchAsync(queryString, cb) {
      if (queryString) {
        this.getDishBase(queryString, (item) => {
          if (item) {
            item.data.items.map((items) => (items.value = items.name));
            cb(item.data.items || []);
          } else {
            cb([]);
          }
        });
      }
    },
    handleSelect(item) {
      this.form.name = item.name;
      this.form.intro = item.intro;
      this.form.calorie = item.calorie;
      this.form.carbohydrate = item.carbohydrate;
      this.form.fat = item.fat;
      this.form.protein = item.protein;
      this.form.na = item.na;
      this.form.dish_base_id = item.id;
      (this.form.oil = item.oil),
        (this.form.salt = item.salt),
        (this.form.sugar = item.sugar),
        (this.fileList = [
          {
            url: item.image,
            response: { key: item.image },
          },
        ]);
    },
    testData(data) {
      let test = true;
      for (let index in data) {
        if ((!data[index] && data[index] !== 0) || data[index] === null) {
          test = false;
        }
      }
      return test;
    },
    setStore_ca() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_list_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines_list
      }

      const datas = {
        name: this.ca_form.name,
        intro: this.ca_form.intro,
        c_type: this.ca_form.c_type,
        shop_id: this.formInline.shop_id,
        order_seq: 23,
        parent_id: 0,
      };
      console.log(datas);
      if (!this.testData(datas)) {
        this.$alert('类目信息不能为空');
        return;
      }
      this.$http.post(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible_ca = false;
          this.getCategory();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增类目失败');
        }
        console.log(res);
      });
    },
    setForm_ca() {
      this.ca_form = {
        name: '',
        c_type: 1,
      };
    },
    onSubmit_ca() {
      this.dialogFormVisible_ca = true;
      this.setForm_ca();
    },
    categoryList(id) {
      this.formInline.category_ids = id;
      this.user_dish_list_id = '';
      this.form = {};
      this.getTableData();
    },
    getdish_unit_id() {
      let list = this.form.dish_unit_id.map((item) => {
        if (this.unitData.find((items) => items.id === item)) {
          const value = this.unitData.find((items) => items.id === item);
          return {
            created_at: value.value,
            display_name: value.display_name,
            id: value.id,
            name: value.name,
            unit_amount: value.unit_amount,
            updated_at: value.updated_at,
          };
        }
      });
      list = list.map((item) => {
        const test = this.unitList.find((items) => items.id === item.id);
        if (test) {
          test.price && (item.price = test.price);
          test.vip_price && (item.vip_price = test.vip_price);
        }
        return item;
      });

      this.unitList = list;
      const isInput = this.unitData.find((item) => {
        if (
          item.id === this.form.dish_unit_id[0] &&
          item.unit_amount === 50 &&
          item.name == '克'
        ) {
          return item;
        }
      });
      if (isInput) {
        this.isInput = false;
      } else {
        this.isInput=true;
      }
    },
    // 点击标签属性
    setLaole(id) {
      this.dialogFormVisibleLabel = true;
      this.Label_dish_attr = {
        dish_attr_id: '',
        dish_attr_value_id: '',
        dish_id: id,
      };
    },
    // 获取单位列表
    getUnitData() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_unit_platform
      } else {
        baseUrl = this.$userList.user_dish_unit
      }
      console.log(this.platform)
      console.log(baseUrl)
      const url = baseUrl + '/1/900';
      console.log(url)
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.unitData = res.data.items;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    //新增标签属性
    postLaole() {
      const { dish_attr_value_id } = this.Label_dish_attr;
      console.log(this.Label_dish_attr);
      if (!dish_attr_value_id) {
        this.$alert('标签或标签属性不能为空');
        return;
      }
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_map_platform
      } else {
        baseUrl = this.$userList.user_dish_attr_map
      }

      const value = this.attrList.find(
        (item) => item.id === dish_attr_value_id
      );
      const data = {
        dish_attr_id: value.dish_attr_id,
        dish_attr_value_id: value.id,
        dish_id: this.Label_dish_attr.dish_id,
      };
      this.$http.post(baseUrl, data).then(() => {
        this.getTableData();
        console.log(this.categorySet, '???');
        this.dialogFormVisibleLabel = false;
      });
    },
    deleteLaole(id) {
      this.$confirm('此操作将删除标签属性, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_attr_map_platform
        } else {
          baseUrl = this.$userList.user_dish_attr_map
        }
        const url = baseUrl + '/' + id;
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除失败');
          }
        });
      });
    },
    //修改商品类目
    setCategory(index) {
      if (this.platform === '0'){
        this.dialogFormVisibles = true;
        console.log(this.categorySet, '???');
        this.categorySet = index;
        this.putCategoryTest = true;
      }
    },
    //新增商品类目
    setCategorys(index) {
      this.dialogFormVisibles = true;
      this.categorySet = index;
      this.categorySet.category_id = '';
      this.putCategoryTest = false;
    },
    postCategory() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_category_dish_platform
      } else {
        baseUrl = this.$userList.user_category_dish
      }
      if (!this.categorySet.category_id) {
        this.$alert('所属类目不能为空');
        return;
      }
      const data = {
        category_id: this.categorySet.category_id,
        dish_id: this.categorySet.id,
        order_seq: 23,
        sticky: 1,
      };
      this.$http.post(baseUrl, data).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisibles = false;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    putCategory() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_category_dish_platform
      } else {
        baseUrl = this.$userList.user_category_dish
      }
      if (!this.categorySet.category_id) {
        this.$alert('所属类目不能为空');
        return;
      }
      const data = {
        category_id: this.categorySet.category_id,
        dish_id: this.categorySet.dish_id,
        order_seq: this.categorySet.order_seq,
        sticky: this.categorySet.sticky,
        id: this.categorySet.id,
      };
      this.$http.put(baseUrl, data).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisibles = false;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    deleteCategory(id) {
      this.$confirm('此操作将删除类目, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_category_dish_platform
        } else {
          baseUrl = this.$userList.user_category_dish
        }
        const url = tbaseUrl + '/' + id;
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除失败');
          }
        });
      });
    },
    setFormInline() {
      this.formInline.name = '';
      this.formInline.dish_attr_value_ids = '';
      this.formInline.dish_attr_id = '';
      this.getTableData();
    },
    setFormInlines() {
      this.formInline = {
        // 门店
        shop_id: 0,
        //搜索
        name: '',
        //类目
        category_ids: '',
        //标签
        dish_attr_value_ids: '',
      };
      this.getTableData();
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
            if (res.code === 200) {
              this.typeData = res.data.items;
              this.formInline.shop_id = res.data.items[0].id;
              this.getCategory();
            } else {
              res.message && this.$alert(res.message);
            }
      // if (this.platform === '1') {
      //   this.getCategory();
      // } else {
      //   this.$http.get(url).then((res) => {
      //     if (res.code === 200) {
      //       this.typeData = res.data.items;
      //       this.formInline.shop_id = res.data.items[0].id;
      //       this.getCategory();
      //     } else {
      //       res.message && this.$alert(res.message);
      //     }
      //   });
      })
    },
    //获取基础菜品
    getDishBase(query_text, fn) {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_base_platform
      } else {
        baseUrl = this.$userList.user_dish_base
      }
      this.$http
        .post(baseUrl, {
          shop_id: this.formInline.shop_id,
          query_text,
        })
        .then((res) => {
          if (res.code === 200) {
            fn(res);
          } else {
            fn(false);
          }
        });
    },

    getLabelList() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_label_list_platform
      } else {
        baseUrl = this.$userList.user_label_list
      }

      const _this = this;
      const data = {
        shop_id: this.formInline.shop_id,
      };
      this.$http.post(baseUrl, data).then((res) => {
        if (res.code === 200) {
          _this.attrList = res.data.items || [];
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    getRaws(){
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_raw_platform
      } else {
        baseUrl = this.$userList.user_dish_raw
      }
      const url2 = baseUrl + '/0/1000'

      this.$http.get(url2).then(res => {
        if (res.code === 200) {
          this.rawData = res.data.items.map(items => {
            return items;
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //获取类目getLabelgetCategory
    getCategory() {
      this.formInline.category_ids = '';
      let data = {
        parent_id: 0,
        shop_id: this.formInline.shop_id,
        menu_id: 0,
        category_type: 1,
      };


      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines
      }

      const url = baseUrl + '/0/998';


      this.$http.get(url, data).then((res) => {
        if (res.code === 200) {
          this.categoryData = res.data.items;
          this.formInline.category_ids =
            (res.data.items.length && res.data.items[0].id) || '';
          this.formInline.dish_attr_value_ids = '';
          this.formInline.dish_attr_id = '';
          this.form = {};
          this.getLabelList();
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 获取列表
    getTableData() {

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_list_platform
      } else {
        baseUrl = this.$userList.user_dish_list
      }
      const url = baseUrl + '/0/99';

      const data = {
        // 门店
        shop_id: this.formInline.shop_id,
        //搜索
        name: this.formInline.name,
        //类目
        category_ids: this.formInline.category_ids,
        //标签
        dish_attr_value_ids: this.formInline.dish_attr_value_ids,
      };
      this.$http.get(url, data).then((res) => {
        if (res.code === 200) {
          this.tableData =
            (res.data.items &&
              res.data.items.map((items) => {
                items.created_at = fecha.format(
                  new Date(items.created_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.updated_at = fecha.format(
                  new Date(items.updated_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.dish_unit_prices = items.dish_unit_prices.map((item) => {
                  item.price = item.price / 100;
                  item.vip_price = item.vip_price / 100;
                  return item;
                });
                return items;
              })) ||
            [];
          // debugger;
          // this.tableRawData = (res.data.items && res.data.items.dish_ingredients) || []
          if (this.form.id) {
            this.getEdit(this.form);
          }
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    //详细信息
    getEdit(row) {
      // this.putStatus = true;

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }
      const url = baseUrl + '/' + row.id;


      this.user_dish_list_id = row.id;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.dish_unit_prices = res.data.dish_unit_prices.map((item) => {
            item.price = item.price / 100;
            item.vip_price = item.vip_price / 100;
            return item;
          });

          this.tableRawData = res.data.dish_ingredients
          this.listZ(res.data);
          // this.dialogFormVisible = true;
          this.putStatus = true;
          // isInput
          const isInput = this.unitData.find((item) => {
            if (
              item.id === this.form.dish_unit_id[0] &&
              item.unit_amount === 50 &&
              item.name == '克'
            ) {
              return item;
            }
          });
          if (isInput) {
            this.isInput = false;
          } else {
            this.isInput=true;
          }
          console.log(this.isInput);
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
    },
    listZ(data) {
      const list = [];
      data.dish_unit_id = data.dish_unit_prices.map((item) => {
        list.push({
          display_name: '',
          id: item.dish_unit_id,
          name: item.dish_unit.name,
          unit_amount: item.dish_unit.unit_amount,
          price: item.price,
          vip_price: item.vip_price,
        });

        return item.dish_unit_id;
      });
      this.unitList = list;
      data.category_id = data.category_dishes.map((item) => item.category_id);
      data.dish_attr_id = [
        ...new Set(data.dish_attr_map.map((item) => item.dish_attr_value_id)),
      ];
      data.dish_base_id = data.dish_base.id;
      const a = {
        ...data.dish_base,
        ...data,
      };
      this.form = a;
      this.fileList = [
        {
          url: data.dish_base.image,
          response: { key: data.dish_base.image },
        },
      ];
    },
    //打开编辑弹窗
    handleEdit(form) {
      this.dialogFormVisible = true;
      this.putStatus = true;
      this.getEdit(form);
    },
    copyPlatformDish(row){
      let url = this.$userList.copy_platform_dish + row.id + "/" + this.formInline.shop_id
      this.$http.post(url, {}).then(res => {
        if (res.code === 200) {
          this.$message('复制成功');
          return;
        }
        if (res.code !== 200) {
          this.$alert('失败,' + res.message);
        }
      })
    },
    stopCopyLogs(){
      this.dialogCopyVisible = false
      this.copyDishLog = ''
      console.log(this.interval)
      clearInterval(this.interval)
    },
    copyAll(){
      this.dialogCopyVisible = true
      let url = this.$userList.copy_dish_platform_url + this.formInline.shop_id
      this.$http.post(url, {}).then(res => {
        if(res.code === 200){
          let jobId = res.data
          let url = this.$userList.copy_dish_platform_log + jobId
          this.interval = setInterval(() => {
            this.$http.get(url).then(res2 => {
              if(res2.code === 200){
                this.copyDishLog = res2.data
              }
            })
          }, 2000);
        }
      })
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将删除标签, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_attr_platform
        } else {
          baseUrl = this.$userList.user_dish_attr
        }

        const url = baseUrl + '/' + row.id
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.form = {};
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除菜品失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible = false;
      this.dialogFormVisible_ca = false;
    },
    setForm() {
      this.form = {
        name: '',
        searchAsync: '',
        amount: 50,
        deviation: 0,
        raw_num: 0,
        raw_category: '',
        raw_unit: ''
      };
      this.fileList = [];
      this.unitList = [];
    },
    onSubmit() {
      this.dialogFormVisible = true;
      this.putStatus = false;
      this.setForm();
    },
    statusStore(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.putStatus) {
            this.setStore();
          } else {
            this.putDtore();
          }
        } else {
          return false;
        }
      });
    },
    setStore() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }

      let datas = this.getDatas();
      datas.dish.dish_base_id = this.form.dish_base_id;
      this.$http.post(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增菜品失败');
        }
      });
    },
    getDatas(id) {
      if(this.isInput){
      } else {
        console.log('per 50g, set deviation 0')
        this.form.deviation = 0
      }
      let datas = {
        dish: {
          id,
          dish_base: {
            name: this.form.name,
            shop_id: this.formInline.shop_id,
            intro: this.form.intro,
            image: (this.fileList.length && this.fileList[0].url) || '',
            calorie: +this.form.calorie,
            fat: +this.form.fat,
            carbohydrate: +this.form.carbohydrate,
            protein: +this.form.protein,
            na: +this.form.na,
            id: this.form.dish_base_id,
            oil: +this.form.oil,
            salt: +this.form.salt,
            sugar: +this.form.sugar,
          },
          dish_base_id: this.form.dish_base_id,
          deviation: +this.form.deviation,
          amount: +this.form.amount,
        },
        dish_categories:
          (this.form.category_id &&
            this.form.category_id.map((item) => {
              return {
                category_id: +item,
                sticky: 1,
                order_seq: 22,
              };
            })) ||
          [],
        dish_attr_maps: [],
        dish_unit_prices:
          (this.unitList.length &&
            this.unitList.map((item) => {
              return {
                dish_unit_id: item.id,
                price: +(+item.price * 100).toFixed(0),
                vip_price: +(+item.vip_price * 100).toFixed(0),
                type: 2,
                order_seq: 1,
              };
            })) ||
          [],
        dish_ingredients:(this.tableRawData.length && this.tableRawData.map(item => {
          return {
            amount: parseInt(item.amount),
            dish_raw_id: item.raw_id,
            category: item.category,
            unit: item.raw_unit,
            raw_name: item.raw_name,
            raw_price: item.raw_price,
            unit_price : item.unit_price,
            dish_id: id,
          }

        })) || [],
      };
      this.attrList.map((item) => {
        const value = this.form.dish_attr_id.find((items) => items === item.id);
        if (value)
          datas.dish_attr_maps.push({
            dish_attr_id: item.dish_attr_id,
            dish_attr_value_id: item.id,
          });
      });
      if (!this.putStatus) {
        datas.dish.dish_type = 1;
      }
      return datas;
    },
    putDtore() {
      const datas = this.getDatas(this.form.id);
      console.log(datas, this.form);


      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }
      

      this.$http.put(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改菜品失败');
        }
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then((res) => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.name !== file.name) {
          return item;
        }
      });
    },
    getTotal(param) {
      const { columns, data } = param;
      const sums = [];
      console.log('------------------------------------')
      console.log("data:", data)
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        console.log("index:",index)
        console.log("column:",column)
        const values = data.map(item => Number(item['raw_price']));
        const amounts = data.map(item => Number(item['amount']));
        let uint = "千克"
        if(data.length > 0) {
          uint = data[0].raw_unit
        }
        console.log("values:", amounts)
        if (index === 2) {
          sums[index] = amounts.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0)  + uint ;
        }
        else if (index === 3) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0) /100.0 + "元";
        } else {
          sums[index] = '--';
        }
      });
      return sums;
    }
  },
  created() {
    this.$root.setheadName();
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    if (platform){
      this.platform = platform
    }
    this.$root.setheadName();
    this.getType();
    this.getUnitData();
    this.getRaws()
  },

};
</script>

<style >
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
input:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
.webList {
  width: 500px;
  height: 700px;
  display: flex;
  border: solid 1px #000;
  overflow: hidden;
  position: relative;
  background: url('../../assets/background.jpg') no-repeat;
  background-size: 100% 100%;
}
.webList_1 {
  flex: 1;
  height: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_1_name {
  height: 50px;
  line-height: 50px;
  color: #fff;
  display: flex;
  align-items: center;
}
.name_color {
  background: #31a6ba;
}
.webList_2 {
  flex: 2;
  height: 100%;
  overflow-x: auto;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_icon {
  width: 30px;
  height: 30px;
  background: #fff;
  margin: 0 10px;
}
.webList_2_list {
  width: 100%;
  height: auto;
  color: #fff;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
}
.webList_2_img {
  background: #fff;
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.webList_2_name {
  font-size: 25px;
  font-weight: 900;
}
.webList_2_value {
  border-top: solid 1px rgba(197, 197, 197, 0.5);
  padding-top: 4px;
}
.webListValue {
  width: 500px;
  height: 700px;
  background: url('../../assets/background.jpg') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  margin-left: 20px;
  overflow-x: auto;
}
.value_name {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 900;
  margin-top: 40px;
  margin-bottom: 10px;
}
.value_namex {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 20px;
}
.value_names {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin: 10px 0;
}
.value_price {
  color: #ff7207;
  font-size: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.value_price_s {
  /* font-size: 35px;
  font-weight: 900;
  line-height: 35px; */
  margin-right: 10px;
}
.value_attr {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 20px;
}
.value_attr_s {
  overflow-y: auto;
  display: flex;
}
.value_progress {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}
.value_progress_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.bottom_centers_y {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
}
.vubuttons {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #1789fb;
  box-sizing: border-box;
  margin: 0 20px;
  border-radius: 10px;
}
.dishAttrValue {
  display: flex;
  box-sizing: border-box;
  padding-left: 130px;
  flex-wrap: wrap;
}
</style>
